import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { closeFinishChatModal } from 'src/store/modules/chat/actions';
import { FinishChatService, OrderService } from '../service';
import {
  type FinishChatFormValue,
  COMMERCIAL_VALUES,
  ORIGIN_VALUES,
} from '../useFinishChatForm';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

export function useFinishChatModal() {
  const mockCluster = 'inactive';

  // Traduções
  const finishChatError = useGlotaT('spa.toasts.chat.finishChatError');

  const currentCustomerId = useSelector(
    (state: any) => state?.general?.current_customer_id
  );

  const userCustomers = useSelector(
    (state: any) => state.chat?.config?.user?.customers
  );
  const currentAccountUuid = userCustomers?.find(
    (customer: any) => customer.id === currentCustomerId
  )?.uuid;

  const currentUser = useSelector((state: any) => state.chat?.config?.user);
  const currentUserUuid = currentUser?.uuid;

  const currentChat = useSelector((state: any) =>
    state.chat?.chats?.find((chat: any) => chat.open === true)
  );

  const currentContactUuid =
    currentChat?.contact?.uuid || currentChat?.contact?.contact_uuid;

  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(closeFinishChatModal());
  }, [dispatch]);

  const handleFinishChat = useCallback(
    async (data: FinishChatFormValue) => {
      setIsLoading(true);

      if (
        data?.origin === ORIGIN_VALUES.commercial &&
        data?.commercial?.type === COMMERCIAL_VALUES.sale_completed
      ) {
        try {
          const orderData = treatOrderData(
            data?.commercial?.order,
            currentContactUuid,
            currentUserUuid
          );

          await OrderService.createOrder(
            orderData,
            currentUserUuid,
            currentAccountUuid
          );
        } catch (error) {
          console.log('erro ao criar um pedido', error);
        }
      }

      const finishChatData = treatFinishChatData(data);

      try {
        await FinishChatService.finishChat(currentContactUuid, finishChatData);

        handleClose();
      } catch (error) {
        console.log('error ao finalizar chat', error);
        toast.error(finishChatError);
      }

      setIsLoading(false);
      handleClose();
    },
    [
      currentContactUuid,
      currentUserUuid,
      currentAccountUuid,
      dispatch,
      handleClose,
    ]
  );

  const treatFinishChatData = useCallback((data: FinishChatFormValue) => {
    const { origin, commercial, botflow: botflowForm } = data;
    let type: string = data[data.origin] as string;
    let botflow: string | null = null;

    if (origin === ORIGIN_VALUES.other) {
      type = origin as string;
    }

    if (origin === ORIGIN_VALUES.commercial) {
      type = commercial?.type as string;
    }

    if (botflowForm?.flow_id && botflowForm?.flow_id !== 'null') {
      botflow = botflowForm.flow_id;
    }

    return {
      origin,
      type,
      botflow,
    };
  }, []);

  const treatOrderData = useCallback(
    (
      data: FinishChatFormValue['commercial']['order'],
      contactUuid: string,
      userUuid: string
    ) => {
      const { name, value, payment, status, sales_status } = data;

      return {
        title: name as string,
        value: (Number(value) / 100) as number,
        status: status as string,
        payment_method: payment as string,
        sales_status: sales_status as string, // >> confirmar com o Cruz esse campo
        contact_uuid: contactUuid,
        responsible_uuid: userUuid,
      };
    },
    []
  );

  return {
    isOpen: currentChat?.finish_chat_modal_open,
    isLoading,
    cluster: mockCluster,
    handleClose,
    handleFinishChat,
  };
}
